import { cbHttp } from "./http.service";

export interface VersionInfo {
    "CB-Admin-v2": string;
    "System": string;
    "Build": string;
}

export const getVersion = async (): Promise<VersionInfo> => {
    try {
        // Use the proper API endpoint instead of accessing public folder directly
        const response = await cbHttp.get('/api/version');
        const versionInfo = response as unknown as Record<string, string>;
        
        return {
            "CB-Admin-v2": versionInfo["CB-Admin-v2"] || "Unknown",
            "System": versionInfo["System"] || "Unknown", 
            "Build": versionInfo["Build"] || "Unknown"
        };
    } catch (error) {
        console.error('Failed to fetch version info:', error);
        return {
            "CB-Admin-v2": "Unknown",
            "System": "Unknown",
            "Build": "Unknown"
        };
    }
}

export const getSystemVersion = async (): Promise<string> => {
    try {
        const versionInfo = await getVersion();
        return versionInfo.System;
    } catch (error) {
        console.error('Failed to fetch system version:', error);
        return "Unknown";
    }
}

export const getAppVersion = async (): Promise<string> => {
    try {
        const versionInfo = await getVersion();
        return versionInfo["CB-Admin-v2"];
    } catch (error) {
        console.error('Failed to fetch app version:', error);
        return "Unknown";
    }
}

export const getBuildDate = async (): Promise<string> => {
    try {
        const versionInfo = await getVersion();
        return versionInfo.Build;
    } catch (error) {
        console.error('Failed to fetch build date:', error);
        return "Unknown";
    }
}